import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Vega',
    key: 'vega',
    order: 185,
    columnLables: {
      current_market_risk_measure_value: {
        name: 'Current Market',
        letter: 'A'
      },
      lower_market_risk_measure_value: {
        name: 'Lower Market',
        letter: 'B'
      },
      higher_market_risk_measure_value: {
        name: 'Higher Market',
        letter: 'C'
      },
      risk_measure_description: {
        name: 'Risk measure description',
        letter: 'D'
      }
    }
  }
];

export function Vega({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.VEGA_RISK_MEASURE,
    onChangeFund,
    schema: schema.VEGA_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.VEGA_RISK_MEASURE?.field_names || [],
    tableName: 'VEGA_RISK_MEASURE',
    isMultiFunds,
    funds,
    tables: _tables,
    isSingleData: true
  });

  return (
    <StyledTables id="fca-reporttables-vega-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-vega-table-${index + 1}`}
          key={index + 'VEGA_RISK_MEASURE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
